
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta } from "/home/vsts/work/1/s/pages/index.vue?macro=true";
import { default as keuzeA266mMa5M4eMKuEENtTPmcKxspiU_E7vKZLf_45KNO9P8Meta } from "/home/vsts/work/1/s/pages/keuze.vue?macro=true";
import { default as login2oDuAJw7jtPFfxdlIexRxoXb75ZKhNHj9lAAm_S3j0MMeta } from "/home/vsts/work/1/s/pages/login.vue?macro=true";
import { default as _91slug_936LkbB91YE4NmN_OgOR5uXz5rwrjxfLgco8m5OC3A_48Meta } from "/home/vsts/work/1/s/pages/[slug].vue?macro=true";
import { default as geluktA5M6K2xJevopLu9GR5thEZFV0gEZfzwOBiwdy6D6nZoMeta } from "/home/vsts/work/1/s/pages/gelukt.vue?macro=true";
import { default as account8lstjryvoMCrpaRTGWbBiyuYZoXqHRraVfMtaQI7PkwMeta } from "/home/vsts/work/1/s/pages/account.vue?macro=true";
import { default as betalenxD_mFmyEl7_45BFg_45N2XpccOpQjBLvtYyyMhvsKexvjZUMeta } from "/home/vsts/work/1/s/pages/betalen.vue?macro=true";
import { default as contactPHFCmtID5EQxIxdSd46SzzmfNp5Nu4AHEsz457o286UMeta } from "/home/vsts/work/1/s/pages/contact.vue?macro=true";
import { default as privacyEVv4SCHpfBpEz39aDEhKu90pUoU8_45K44E2qMi6eCeUwMeta } from "/home/vsts/work/1/s/pages/privacy.vue?macro=true";
import { default as inloggen__45Yn6Zi9zSc_455Lanr7bJaCgd88Kb6aRE1MFg7fu_qjgMeta } from "/home/vsts/work/1/s/pages/inloggen.vue?macro=true";
import { default as aanmelden9vkhqa5qdgSohOpS3kW1PbKLFEI_KCrNy_ncGszB_lkMeta } from "/home/vsts/work/1/s/pages/aanmelden.vue?macro=true";
import { default as overzicht6XeBkFHQohJFbleQ5yETUEevDWv2FmhwxsJ_457zvU1FEMeta } from "/home/vsts/work/1/s/pages/overzicht.vue?macro=true";
import { default as indexLSYDdJLKDR24yC_454KtNGURLiZHTiuQWE9aOpzCc792MMeta } from "/home/vsts/work/1/s/pages/help/index.vue?macro=true";
import { default as indexCS9f_45IEi50MohJGibrAm_45757zWxwffi8tvm32Xw0vHQMeta } from "/home/vsts/work/1/s/pages/shop/index.vue?macro=true";
import { default as _91slug_935JSF8CwuWF_459WBZ8knVxW8_XP5HOEf0giseAt04w6OIMeta } from "/home/vsts/work/1/s/pages/boek/[slug].vue?macro=true";
import { default as geluktu_45oeQzHyEqzk71FCLUgZ6ODAGdOwPVV_45o3_45_45jt2H44wMeta } from "/home/vsts/work/1/s/pages/shop/gelukt.vue?macro=true";
import { default as index2IPAnYg9lgHapqnlYhv2Wg0lFNecxj_io6w5sbIAF_oMeta } from "/home/vsts/work/1/s/pages/boeken/index.vue?macro=true";
import { default as _91slug_93rL1yE01Shc4VNF8h56XXf5KX_45uTkPy27S9NVNF9Bfy0Meta } from "/home/vsts/work/1/s/pages/lezen/[slug].vue?macro=true";
import { default as lidmaatschaplBp_g09wMNEKCKBWFQY38S8_45rK325Hgrj2IRDeTa8koMeta } from "/home/vsts/work/1/s/pages/lidmaatschap.vue?macro=true";
import { default as _91slug_930w5TqlRXwvjBrBMtSnWERJDi6zuB1OkhAeCuMngeF5UMeta } from "/home/vsts/work/1/s/pages/promo/[slug].vue?macro=true";
import { default as gelukt7UVWgI6B_vP_miRW_45DFxftqnGrUAITPAQg20GTfw17sMeta } from "/home/vsts/work/1/s/pages/promo/gelukt.vue?macro=true";
import { default as betalenwI3PkO2owVZuxHDZYXd16YxWkYZoJ1b344le5n_45m1NkMeta } from "/home/vsts/work/1/s/pages/shop/betalen.vue?macro=true";
import { default as indexlSmKq_sxikp8lEWfKMt8LnYkvpwvbROzzYnTIzLm1RAMeta } from "/home/vsts/work/1/s/pages/archief/index.vue?macro=true";
import { default as betalenLwS0K67pgxXshFo0WY90GQhozzXW0i_Xyce0usAQ7jAMeta } from "/home/vsts/work/1/s/pages/promo/betalen.vue?macro=true";
import { default as _91month_935QQ63Bs10s2366V_45ciw5NsevgbEszsaFP0Rh6fH3l2gMeta } from "/home/vsts/work/1/s/pages/boeken/[month].vue?macro=true";
import { default as inloggenn894MPhQ_450OrA4a6T2Db0qGJlMzfsM3Ofbd40PN7InoMeta } from "/home/vsts/work/1/s/pages/promo/inloggen.vue?macro=true";
import { default as aanmeldeni4GXXbdgAo_1PZ5VxJ14_SSZMS_45GwMu4Lwnf3B_ZQ6IMeta } from "/home/vsts/work/1/s/pages/shop/aanmelden.vue?macro=true";
import { default as _91slug_93qWlDDRhc8koPy1I3pcNXqUMTKkKlfdx7GtR2uZWzv24Meta } from "/home/vsts/work/1/s/pages/campagne/[slug].vue?macro=true";
import { default as aanmeldencLbz_45fR50TmuoonAopTNP0yDDyMyn7fJ_450CdYS3fyQ4Meta } from "/home/vsts/work/1/s/pages/promo/aanmelden.vue?macro=true";
import { default as overzichti5tjXkx_45STysVQt5zqDbTsUysbM7TajkIoABdkR5fdEMeta } from "/home/vsts/work/1/s/pages/promo/overzicht.vue?macro=true";
import { default as _91slug_934G9IW3dN6rSxOeUJPabnRSIPPwaXgBEX90UlsqVWZv4Meta } from "/home/vsts/work/1/s/pages/exclusive/[slug].vue?macro=true";
import { default as _91slug_93xIp3Xxj6mSpZoOL8bk69M4pTOtQqlu34pjO9HtsvYSEMeta } from "/home/vsts/work/1/s/pages/shop/boek/[slug].vue?macro=true";
import { default as indexwjQ7NVUXxiR0dGRxdexfgXvZBEDH2PvUto5_fdPDOv0Meta } from "/home/vsts/work/1/s/pages/shopboeken/index.vue?macro=true";
import { default as indexOQFvQQJ4FlGKlu0ibmPwhIB_45yA1LPvwkeVxswPmkNOgMeta } from "/home/vsts/work/1/s/pages/boekenpraat/index.vue?macro=true";
import { default as _91slug_93nXapy0aUU_DZzxuxTCDLZRFsJnTtu_SM_45_45P93ZaTYegMeta } from "/home/vsts/work/1/s/pages/boekenpraat/[slug].vue?macro=true";
import { default as wachtwoord_45vergetenPLlBIL91__ETXBBwRKr3mLE83db7w_45m23xPAYnRY0icMeta } from "/home/vsts/work/1/s/pages/wachtwoord-vergeten.vue?macro=true";
import { default as algemene_45voorwaarden1chv4cbzzXep_kbnhOMHiswwhMbXYqBqvz1o_45xJMfhoMeta } from "/home/vsts/work/1/s/pages/algemene-voorwaarden.vue?macro=true";
import { default as wachtwoord_45herstellenWXYRzTmVpSG3t0bd0Fv7GzV73tMjPZjfq_45C8B62YQF4Meta } from "/home/vsts/work/1/s/pages/wachtwoord-herstellen.vue?macro=true";
import { default as nieuwsbrief_45instellingen44u8U40fm83UaG3GZISxhHn86LFuHef7epgmEpyC7vYMeta } from "/home/vsts/work/1/s/pages/nieuwsbrief-instellingen.vue?macro=true";
import { default as index7cJvl0uoOYdrVuUiHu47PmCeebvviFliZJpMqShDMJwMeta } from "~/pages/boeken/index.vue?macro=true";
import { default as aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta } from "~/pages/promo/aanmelden.vue?macro=true";
import { default as betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta } from "~/pages/promo/betalen.vue?macro=true";
import { default as geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta } from "~/pages/promo/gelukt.vue?macro=true";
import { default as overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta } from "~/pages/promo/overzicht.vue?macro=true";
import { default as inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta } from "~/pages/promo/inloggen.vue?macro=true";
import { default as _91slug_93Z_45hD6NNoHwxITjLDGraPRWho6xkzF3rywrNmjbwPPvkMeta } from "~/pages/lezen/[slug].vue?macro=true";
import { default as index79Dtf__45zjyxjEqMVtlBDDX2KfC1j95a69AqafAVtBGUMeta } from "~/pages/archief/index.vue?macro=true";
import { default as indexRgFr3GujSt_uqIVaAl6xQwLR_phmsmPXCk14NuLQuqwMeta } from "~/pages/help/index.vue?macro=true";
export default [
  {
    name: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta?.name ?? "index",
    path: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta?.path ?? "/",
    props: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta?.props ?? false,
    meta: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta || {},
    alias: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta?.alias || [],
    redirect: indexLiSwOG_45EnsyrzSv9J7wVbtUE3hBMYBvu0fyT1w_45g_y8Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/index.vue")
  },
  {
    name: keuzeA266mMa5M4eMKuEENtTPmcKxspiU_E7vKZLf_45KNO9P8Meta?.name ?? "keuze",
    path: keuzeA266mMa5M4eMKuEENtTPmcKxspiU_E7vKZLf_45KNO9P8Meta?.path ?? "/keuze",
    props: keuzeA266mMa5M4eMKuEENtTPmcKxspiU_E7vKZLf_45KNO9P8Meta?.props ?? false,
    meta: keuzeA266mMa5M4eMKuEENtTPmcKxspiU_E7vKZLf_45KNO9P8Meta || {},
    alias: keuzeA266mMa5M4eMKuEENtTPmcKxspiU_E7vKZLf_45KNO9P8Meta?.alias || [],
    redirect: keuzeA266mMa5M4eMKuEENtTPmcKxspiU_E7vKZLf_45KNO9P8Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/keuze.vue")
  },
  {
    name: login2oDuAJw7jtPFfxdlIexRxoXb75ZKhNHj9lAAm_S3j0MMeta?.name ?? "login",
    path: login2oDuAJw7jtPFfxdlIexRxoXb75ZKhNHj9lAAm_S3j0MMeta?.path ?? "/login",
    props: login2oDuAJw7jtPFfxdlIexRxoXb75ZKhNHj9lAAm_S3j0MMeta?.props ?? false,
    meta: login2oDuAJw7jtPFfxdlIexRxoXb75ZKhNHj9lAAm_S3j0MMeta || {},
    alias: login2oDuAJw7jtPFfxdlIexRxoXb75ZKhNHj9lAAm_S3j0MMeta?.alias || [],
    redirect: login2oDuAJw7jtPFfxdlIexRxoXb75ZKhNHj9lAAm_S3j0MMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/login.vue")
  },
  {
    name: _91slug_936LkbB91YE4NmN_OgOR5uXz5rwrjxfLgco8m5OC3A_48Meta?.name ?? "slug",
    path: _91slug_936LkbB91YE4NmN_OgOR5uXz5rwrjxfLgco8m5OC3A_48Meta?.path ?? "/:slug()",
    props: _91slug_936LkbB91YE4NmN_OgOR5uXz5rwrjxfLgco8m5OC3A_48Meta?.props ?? false,
    meta: _91slug_936LkbB91YE4NmN_OgOR5uXz5rwrjxfLgco8m5OC3A_48Meta || {},
    alias: _91slug_936LkbB91YE4NmN_OgOR5uXz5rwrjxfLgco8m5OC3A_48Meta?.alias || [],
    redirect: _91slug_936LkbB91YE4NmN_OgOR5uXz5rwrjxfLgco8m5OC3A_48Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/[slug].vue")
  },
  {
    name: geluktA5M6K2xJevopLu9GR5thEZFV0gEZfzwOBiwdy6D6nZoMeta?.name ?? "gelukt",
    path: geluktA5M6K2xJevopLu9GR5thEZFV0gEZfzwOBiwdy6D6nZoMeta?.path ?? "/gelukt",
    props: geluktA5M6K2xJevopLu9GR5thEZFV0gEZfzwOBiwdy6D6nZoMeta?.props ?? false,
    meta: geluktA5M6K2xJevopLu9GR5thEZFV0gEZfzwOBiwdy6D6nZoMeta || {},
    alias: geluktA5M6K2xJevopLu9GR5thEZFV0gEZfzwOBiwdy6D6nZoMeta?.alias || [],
    redirect: geluktA5M6K2xJevopLu9GR5thEZFV0gEZfzwOBiwdy6D6nZoMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/gelukt.vue")
  },
  {
    name: account8lstjryvoMCrpaRTGWbBiyuYZoXqHRraVfMtaQI7PkwMeta?.name ?? "account",
    path: account8lstjryvoMCrpaRTGWbBiyuYZoXqHRraVfMtaQI7PkwMeta?.path ?? "/account",
    props: account8lstjryvoMCrpaRTGWbBiyuYZoXqHRraVfMtaQI7PkwMeta?.props ?? false,
    meta: account8lstjryvoMCrpaRTGWbBiyuYZoXqHRraVfMtaQI7PkwMeta || {},
    alias: account8lstjryvoMCrpaRTGWbBiyuYZoXqHRraVfMtaQI7PkwMeta?.alias || [],
    redirect: account8lstjryvoMCrpaRTGWbBiyuYZoXqHRraVfMtaQI7PkwMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/account.vue")
  },
  {
    name: betalenxD_mFmyEl7_45BFg_45N2XpccOpQjBLvtYyyMhvsKexvjZUMeta?.name ?? "betalen",
    path: betalenxD_mFmyEl7_45BFg_45N2XpccOpQjBLvtYyyMhvsKexvjZUMeta?.path ?? "/betalen",
    props: betalenxD_mFmyEl7_45BFg_45N2XpccOpQjBLvtYyyMhvsKexvjZUMeta?.props ?? false,
    meta: betalenxD_mFmyEl7_45BFg_45N2XpccOpQjBLvtYyyMhvsKexvjZUMeta || {},
    alias: betalenxD_mFmyEl7_45BFg_45N2XpccOpQjBLvtYyyMhvsKexvjZUMeta?.alias || [],
    redirect: betalenxD_mFmyEl7_45BFg_45N2XpccOpQjBLvtYyyMhvsKexvjZUMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/betalen.vue")
  },
  {
    name: contactPHFCmtID5EQxIxdSd46SzzmfNp5Nu4AHEsz457o286UMeta?.name ?? "contact",
    path: contactPHFCmtID5EQxIxdSd46SzzmfNp5Nu4AHEsz457o286UMeta?.path ?? "/contact",
    props: contactPHFCmtID5EQxIxdSd46SzzmfNp5Nu4AHEsz457o286UMeta?.props ?? false,
    meta: contactPHFCmtID5EQxIxdSd46SzzmfNp5Nu4AHEsz457o286UMeta || {},
    alias: contactPHFCmtID5EQxIxdSd46SzzmfNp5Nu4AHEsz457o286UMeta?.alias || [],
    redirect: contactPHFCmtID5EQxIxdSd46SzzmfNp5Nu4AHEsz457o286UMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/contact.vue")
  },
  {
    name: privacyEVv4SCHpfBpEz39aDEhKu90pUoU8_45K44E2qMi6eCeUwMeta?.name ?? "privacy",
    path: privacyEVv4SCHpfBpEz39aDEhKu90pUoU8_45K44E2qMi6eCeUwMeta?.path ?? "/privacy",
    props: privacyEVv4SCHpfBpEz39aDEhKu90pUoU8_45K44E2qMi6eCeUwMeta?.props ?? false,
    meta: privacyEVv4SCHpfBpEz39aDEhKu90pUoU8_45K44E2qMi6eCeUwMeta || {},
    alias: privacyEVv4SCHpfBpEz39aDEhKu90pUoU8_45K44E2qMi6eCeUwMeta?.alias || [],
    redirect: privacyEVv4SCHpfBpEz39aDEhKu90pUoU8_45K44E2qMi6eCeUwMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/privacy.vue")
  },
  {
    name: inloggen__45Yn6Zi9zSc_455Lanr7bJaCgd88Kb6aRE1MFg7fu_qjgMeta?.name ?? "inloggen",
    path: inloggen__45Yn6Zi9zSc_455Lanr7bJaCgd88Kb6aRE1MFg7fu_qjgMeta?.path ?? "/inloggen",
    props: inloggen__45Yn6Zi9zSc_455Lanr7bJaCgd88Kb6aRE1MFg7fu_qjgMeta?.props ?? false,
    meta: inloggen__45Yn6Zi9zSc_455Lanr7bJaCgd88Kb6aRE1MFg7fu_qjgMeta || {},
    alias: inloggen__45Yn6Zi9zSc_455Lanr7bJaCgd88Kb6aRE1MFg7fu_qjgMeta?.alias || [],
    redirect: inloggen__45Yn6Zi9zSc_455Lanr7bJaCgd88Kb6aRE1MFg7fu_qjgMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/inloggen.vue")
  },
  {
    name: aanmelden9vkhqa5qdgSohOpS3kW1PbKLFEI_KCrNy_ncGszB_lkMeta?.name ?? "aanmelden",
    path: aanmelden9vkhqa5qdgSohOpS3kW1PbKLFEI_KCrNy_ncGszB_lkMeta?.path ?? "/aanmelden",
    props: aanmelden9vkhqa5qdgSohOpS3kW1PbKLFEI_KCrNy_ncGszB_lkMeta?.props ?? false,
    meta: aanmelden9vkhqa5qdgSohOpS3kW1PbKLFEI_KCrNy_ncGszB_lkMeta || {},
    alias: aanmelden9vkhqa5qdgSohOpS3kW1PbKLFEI_KCrNy_ncGszB_lkMeta?.alias || [],
    redirect: aanmelden9vkhqa5qdgSohOpS3kW1PbKLFEI_KCrNy_ncGszB_lkMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/aanmelden.vue")
  },
  {
    name: overzicht6XeBkFHQohJFbleQ5yETUEevDWv2FmhwxsJ_457zvU1FEMeta?.name ?? "overzicht",
    path: overzicht6XeBkFHQohJFbleQ5yETUEevDWv2FmhwxsJ_457zvU1FEMeta?.path ?? "/overzicht",
    props: overzicht6XeBkFHQohJFbleQ5yETUEevDWv2FmhwxsJ_457zvU1FEMeta?.props ?? false,
    meta: overzicht6XeBkFHQohJFbleQ5yETUEevDWv2FmhwxsJ_457zvU1FEMeta || {},
    alias: overzicht6XeBkFHQohJFbleQ5yETUEevDWv2FmhwxsJ_457zvU1FEMeta?.alias || [],
    redirect: overzicht6XeBkFHQohJFbleQ5yETUEevDWv2FmhwxsJ_457zvU1FEMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/overzicht.vue")
  },
  {
    name: indexLSYDdJLKDR24yC_454KtNGURLiZHTiuQWE9aOpzCc792MMeta?.name ?? "help",
    path: indexLSYDdJLKDR24yC_454KtNGURLiZHTiuQWE9aOpzCc792MMeta?.path ?? "/help",
    props: indexLSYDdJLKDR24yC_454KtNGURLiZHTiuQWE9aOpzCc792MMeta?.props ?? false,
    meta: indexLSYDdJLKDR24yC_454KtNGURLiZHTiuQWE9aOpzCc792MMeta || {},
    alias: indexLSYDdJLKDR24yC_454KtNGURLiZHTiuQWE9aOpzCc792MMeta?.alias || [],
    redirect: indexLSYDdJLKDR24yC_454KtNGURLiZHTiuQWE9aOpzCc792MMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/help/index.vue")
  },
  {
    name: indexCS9f_45IEi50MohJGibrAm_45757zWxwffi8tvm32Xw0vHQMeta?.name ?? "shop",
    path: indexCS9f_45IEi50MohJGibrAm_45757zWxwffi8tvm32Xw0vHQMeta?.path ?? "/shop",
    props: indexCS9f_45IEi50MohJGibrAm_45757zWxwffi8tvm32Xw0vHQMeta?.props ?? false,
    meta: indexCS9f_45IEi50MohJGibrAm_45757zWxwffi8tvm32Xw0vHQMeta || {},
    alias: indexCS9f_45IEi50MohJGibrAm_45757zWxwffi8tvm32Xw0vHQMeta?.alias || [],
    redirect: indexCS9f_45IEi50MohJGibrAm_45757zWxwffi8tvm32Xw0vHQMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/shop/index.vue")
  },
  {
    name: _91slug_935JSF8CwuWF_459WBZ8knVxW8_XP5HOEf0giseAt04w6OIMeta?.name ?? "boek-slug",
    path: _91slug_935JSF8CwuWF_459WBZ8knVxW8_XP5HOEf0giseAt04w6OIMeta?.path ?? "/boek/:slug()",
    props: _91slug_935JSF8CwuWF_459WBZ8knVxW8_XP5HOEf0giseAt04w6OIMeta?.props ?? false,
    meta: _91slug_935JSF8CwuWF_459WBZ8knVxW8_XP5HOEf0giseAt04w6OIMeta || {},
    alias: _91slug_935JSF8CwuWF_459WBZ8knVxW8_XP5HOEf0giseAt04w6OIMeta?.alias || [],
    redirect: _91slug_935JSF8CwuWF_459WBZ8knVxW8_XP5HOEf0giseAt04w6OIMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/boek/[slug].vue")
  },
  {
    name: geluktu_45oeQzHyEqzk71FCLUgZ6ODAGdOwPVV_45o3_45_45jt2H44wMeta?.name ?? "shop-gelukt",
    path: geluktu_45oeQzHyEqzk71FCLUgZ6ODAGdOwPVV_45o3_45_45jt2H44wMeta?.path ?? "/shop/gelukt",
    props: geluktu_45oeQzHyEqzk71FCLUgZ6ODAGdOwPVV_45o3_45_45jt2H44wMeta?.props ?? false,
    meta: geluktu_45oeQzHyEqzk71FCLUgZ6ODAGdOwPVV_45o3_45_45jt2H44wMeta || {},
    alias: geluktu_45oeQzHyEqzk71FCLUgZ6ODAGdOwPVV_45o3_45_45jt2H44wMeta?.alias || [],
    redirect: geluktu_45oeQzHyEqzk71FCLUgZ6ODAGdOwPVV_45o3_45_45jt2H44wMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/shop/gelukt.vue")
  },
  {
    name: index2IPAnYg9lgHapqnlYhv2Wg0lFNecxj_io6w5sbIAF_oMeta?.name ?? "boeken",
    path: index2IPAnYg9lgHapqnlYhv2Wg0lFNecxj_io6w5sbIAF_oMeta?.path ?? "/boeken",
    props: index2IPAnYg9lgHapqnlYhv2Wg0lFNecxj_io6w5sbIAF_oMeta?.props ?? false,
    meta: index2IPAnYg9lgHapqnlYhv2Wg0lFNecxj_io6w5sbIAF_oMeta || {},
    alias: index2IPAnYg9lgHapqnlYhv2Wg0lFNecxj_io6w5sbIAF_oMeta?.alias || [],
    redirect: index2IPAnYg9lgHapqnlYhv2Wg0lFNecxj_io6w5sbIAF_oMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/boeken/index.vue")
  },
  {
    name: _91slug_93rL1yE01Shc4VNF8h56XXf5KX_45uTkPy27S9NVNF9Bfy0Meta?.name ?? "lezen-slug",
    path: _91slug_93rL1yE01Shc4VNF8h56XXf5KX_45uTkPy27S9NVNF9Bfy0Meta?.path ?? "/lezen/:slug()",
    props: _91slug_93rL1yE01Shc4VNF8h56XXf5KX_45uTkPy27S9NVNF9Bfy0Meta?.props ?? false,
    meta: _91slug_93rL1yE01Shc4VNF8h56XXf5KX_45uTkPy27S9NVNF9Bfy0Meta || {},
    alias: _91slug_93rL1yE01Shc4VNF8h56XXf5KX_45uTkPy27S9NVNF9Bfy0Meta?.alias || [],
    redirect: _91slug_93rL1yE01Shc4VNF8h56XXf5KX_45uTkPy27S9NVNF9Bfy0Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/lezen/[slug].vue")
  },
  {
    name: lidmaatschaplBp_g09wMNEKCKBWFQY38S8_45rK325Hgrj2IRDeTa8koMeta?.name ?? "lidmaatschap",
    path: lidmaatschaplBp_g09wMNEKCKBWFQY38S8_45rK325Hgrj2IRDeTa8koMeta?.path ?? "/lidmaatschap",
    props: lidmaatschaplBp_g09wMNEKCKBWFQY38S8_45rK325Hgrj2IRDeTa8koMeta?.props ?? false,
    meta: lidmaatschaplBp_g09wMNEKCKBWFQY38S8_45rK325Hgrj2IRDeTa8koMeta || {},
    alias: lidmaatschaplBp_g09wMNEKCKBWFQY38S8_45rK325Hgrj2IRDeTa8koMeta?.alias || [],
    redirect: lidmaatschaplBp_g09wMNEKCKBWFQY38S8_45rK325Hgrj2IRDeTa8koMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/lidmaatschap.vue")
  },
  {
    name: _91slug_930w5TqlRXwvjBrBMtSnWERJDi6zuB1OkhAeCuMngeF5UMeta?.name ?? "promo-slug",
    path: _91slug_930w5TqlRXwvjBrBMtSnWERJDi6zuB1OkhAeCuMngeF5UMeta?.path ?? "/promo/:slug()",
    props: _91slug_930w5TqlRXwvjBrBMtSnWERJDi6zuB1OkhAeCuMngeF5UMeta?.props ?? false,
    meta: _91slug_930w5TqlRXwvjBrBMtSnWERJDi6zuB1OkhAeCuMngeF5UMeta || {},
    alias: _91slug_930w5TqlRXwvjBrBMtSnWERJDi6zuB1OkhAeCuMngeF5UMeta?.alias || [],
    redirect: _91slug_930w5TqlRXwvjBrBMtSnWERJDi6zuB1OkhAeCuMngeF5UMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/promo/[slug].vue")
  },
  {
    name: gelukt7UVWgI6B_vP_miRW_45DFxftqnGrUAITPAQg20GTfw17sMeta?.name ?? "promo-gelukt",
    path: gelukt7UVWgI6B_vP_miRW_45DFxftqnGrUAITPAQg20GTfw17sMeta?.path ?? "/promo/gelukt",
    props: gelukt7UVWgI6B_vP_miRW_45DFxftqnGrUAITPAQg20GTfw17sMeta?.props ?? false,
    meta: gelukt7UVWgI6B_vP_miRW_45DFxftqnGrUAITPAQg20GTfw17sMeta || {},
    alias: gelukt7UVWgI6B_vP_miRW_45DFxftqnGrUAITPAQg20GTfw17sMeta?.alias || [],
    redirect: gelukt7UVWgI6B_vP_miRW_45DFxftqnGrUAITPAQg20GTfw17sMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/promo/gelukt.vue")
  },
  {
    name: betalenwI3PkO2owVZuxHDZYXd16YxWkYZoJ1b344le5n_45m1NkMeta?.name ?? "shop-betalen",
    path: betalenwI3PkO2owVZuxHDZYXd16YxWkYZoJ1b344le5n_45m1NkMeta?.path ?? "/shop/betalen",
    props: betalenwI3PkO2owVZuxHDZYXd16YxWkYZoJ1b344le5n_45m1NkMeta?.props ?? false,
    meta: betalenwI3PkO2owVZuxHDZYXd16YxWkYZoJ1b344le5n_45m1NkMeta || {},
    alias: betalenwI3PkO2owVZuxHDZYXd16YxWkYZoJ1b344le5n_45m1NkMeta?.alias || [],
    redirect: betalenwI3PkO2owVZuxHDZYXd16YxWkYZoJ1b344le5n_45m1NkMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/shop/betalen.vue")
  },
  {
    name: indexlSmKq_sxikp8lEWfKMt8LnYkvpwvbROzzYnTIzLm1RAMeta?.name ?? "archief",
    path: indexlSmKq_sxikp8lEWfKMt8LnYkvpwvbROzzYnTIzLm1RAMeta?.path ?? "/archief",
    props: indexlSmKq_sxikp8lEWfKMt8LnYkvpwvbROzzYnTIzLm1RAMeta?.props ?? false,
    meta: indexlSmKq_sxikp8lEWfKMt8LnYkvpwvbROzzYnTIzLm1RAMeta || {},
    alias: indexlSmKq_sxikp8lEWfKMt8LnYkvpwvbROzzYnTIzLm1RAMeta?.alias || [],
    redirect: indexlSmKq_sxikp8lEWfKMt8LnYkvpwvbROzzYnTIzLm1RAMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/archief/index.vue")
  },
  {
    name: betalenLwS0K67pgxXshFo0WY90GQhozzXW0i_Xyce0usAQ7jAMeta?.name ?? "promo-betalen",
    path: betalenLwS0K67pgxXshFo0WY90GQhozzXW0i_Xyce0usAQ7jAMeta?.path ?? "/promo/betalen",
    props: betalenLwS0K67pgxXshFo0WY90GQhozzXW0i_Xyce0usAQ7jAMeta?.props ?? false,
    meta: betalenLwS0K67pgxXshFo0WY90GQhozzXW0i_Xyce0usAQ7jAMeta || {},
    alias: betalenLwS0K67pgxXshFo0WY90GQhozzXW0i_Xyce0usAQ7jAMeta?.alias || [],
    redirect: betalenLwS0K67pgxXshFo0WY90GQhozzXW0i_Xyce0usAQ7jAMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/promo/betalen.vue")
  },
  {
    name: _91month_935QQ63Bs10s2366V_45ciw5NsevgbEszsaFP0Rh6fH3l2gMeta?.name ?? "boeken-month",
    path: _91month_935QQ63Bs10s2366V_45ciw5NsevgbEszsaFP0Rh6fH3l2gMeta?.path ?? "/boeken/:month()",
    props: _91month_935QQ63Bs10s2366V_45ciw5NsevgbEszsaFP0Rh6fH3l2gMeta?.props ?? false,
    meta: _91month_935QQ63Bs10s2366V_45ciw5NsevgbEszsaFP0Rh6fH3l2gMeta || {},
    alias: _91month_935QQ63Bs10s2366V_45ciw5NsevgbEszsaFP0Rh6fH3l2gMeta?.alias || [],
    redirect: _91month_935QQ63Bs10s2366V_45ciw5NsevgbEszsaFP0Rh6fH3l2gMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/boeken/[month].vue")
  },
  {
    name: inloggenn894MPhQ_450OrA4a6T2Db0qGJlMzfsM3Ofbd40PN7InoMeta?.name ?? "promo-inloggen",
    path: inloggenn894MPhQ_450OrA4a6T2Db0qGJlMzfsM3Ofbd40PN7InoMeta?.path ?? "/promo/inloggen",
    props: inloggenn894MPhQ_450OrA4a6T2Db0qGJlMzfsM3Ofbd40PN7InoMeta?.props ?? false,
    meta: inloggenn894MPhQ_450OrA4a6T2Db0qGJlMzfsM3Ofbd40PN7InoMeta || {},
    alias: inloggenn894MPhQ_450OrA4a6T2Db0qGJlMzfsM3Ofbd40PN7InoMeta?.alias || [],
    redirect: inloggenn894MPhQ_450OrA4a6T2Db0qGJlMzfsM3Ofbd40PN7InoMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/promo/inloggen.vue")
  },
  {
    name: aanmeldeni4GXXbdgAo_1PZ5VxJ14_SSZMS_45GwMu4Lwnf3B_ZQ6IMeta?.name ?? "shop-aanmelden",
    path: aanmeldeni4GXXbdgAo_1PZ5VxJ14_SSZMS_45GwMu4Lwnf3B_ZQ6IMeta?.path ?? "/shop/aanmelden",
    props: aanmeldeni4GXXbdgAo_1PZ5VxJ14_SSZMS_45GwMu4Lwnf3B_ZQ6IMeta?.props ?? false,
    meta: aanmeldeni4GXXbdgAo_1PZ5VxJ14_SSZMS_45GwMu4Lwnf3B_ZQ6IMeta || {},
    alias: aanmeldeni4GXXbdgAo_1PZ5VxJ14_SSZMS_45GwMu4Lwnf3B_ZQ6IMeta?.alias || [],
    redirect: aanmeldeni4GXXbdgAo_1PZ5VxJ14_SSZMS_45GwMu4Lwnf3B_ZQ6IMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/shop/aanmelden.vue")
  },
  {
    name: _91slug_93qWlDDRhc8koPy1I3pcNXqUMTKkKlfdx7GtR2uZWzv24Meta?.name ?? "campagne-slug",
    path: _91slug_93qWlDDRhc8koPy1I3pcNXqUMTKkKlfdx7GtR2uZWzv24Meta?.path ?? "/campagne/:slug()",
    props: _91slug_93qWlDDRhc8koPy1I3pcNXqUMTKkKlfdx7GtR2uZWzv24Meta?.props ?? false,
    meta: _91slug_93qWlDDRhc8koPy1I3pcNXqUMTKkKlfdx7GtR2uZWzv24Meta || {},
    alias: _91slug_93qWlDDRhc8koPy1I3pcNXqUMTKkKlfdx7GtR2uZWzv24Meta?.alias || [],
    redirect: _91slug_93qWlDDRhc8koPy1I3pcNXqUMTKkKlfdx7GtR2uZWzv24Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/campagne/[slug].vue")
  },
  {
    name: aanmeldencLbz_45fR50TmuoonAopTNP0yDDyMyn7fJ_450CdYS3fyQ4Meta?.name ?? "promo-aanmelden",
    path: aanmeldencLbz_45fR50TmuoonAopTNP0yDDyMyn7fJ_450CdYS3fyQ4Meta?.path ?? "/promo/aanmelden",
    props: aanmeldencLbz_45fR50TmuoonAopTNP0yDDyMyn7fJ_450CdYS3fyQ4Meta?.props ?? false,
    meta: aanmeldencLbz_45fR50TmuoonAopTNP0yDDyMyn7fJ_450CdYS3fyQ4Meta || {},
    alias: aanmeldencLbz_45fR50TmuoonAopTNP0yDDyMyn7fJ_450CdYS3fyQ4Meta?.alias || [],
    redirect: aanmeldencLbz_45fR50TmuoonAopTNP0yDDyMyn7fJ_450CdYS3fyQ4Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/promo/aanmelden.vue")
  },
  {
    name: overzichti5tjXkx_45STysVQt5zqDbTsUysbM7TajkIoABdkR5fdEMeta?.name ?? "promo-overzicht",
    path: overzichti5tjXkx_45STysVQt5zqDbTsUysbM7TajkIoABdkR5fdEMeta?.path ?? "/promo/overzicht",
    props: overzichti5tjXkx_45STysVQt5zqDbTsUysbM7TajkIoABdkR5fdEMeta?.props ?? false,
    meta: overzichti5tjXkx_45STysVQt5zqDbTsUysbM7TajkIoABdkR5fdEMeta || {},
    alias: overzichti5tjXkx_45STysVQt5zqDbTsUysbM7TajkIoABdkR5fdEMeta?.alias || [],
    redirect: overzichti5tjXkx_45STysVQt5zqDbTsUysbM7TajkIoABdkR5fdEMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/promo/overzicht.vue")
  },
  {
    name: _91slug_934G9IW3dN6rSxOeUJPabnRSIPPwaXgBEX90UlsqVWZv4Meta?.name ?? "exclusive-slug",
    path: _91slug_934G9IW3dN6rSxOeUJPabnRSIPPwaXgBEX90UlsqVWZv4Meta?.path ?? "/exclusive/:slug()",
    props: _91slug_934G9IW3dN6rSxOeUJPabnRSIPPwaXgBEX90UlsqVWZv4Meta?.props ?? false,
    meta: _91slug_934G9IW3dN6rSxOeUJPabnRSIPPwaXgBEX90UlsqVWZv4Meta || {},
    alias: _91slug_934G9IW3dN6rSxOeUJPabnRSIPPwaXgBEX90UlsqVWZv4Meta?.alias || [],
    redirect: _91slug_934G9IW3dN6rSxOeUJPabnRSIPPwaXgBEX90UlsqVWZv4Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/exclusive/[slug].vue")
  },
  {
    name: _91slug_93xIp3Xxj6mSpZoOL8bk69M4pTOtQqlu34pjO9HtsvYSEMeta?.name ?? "shop-boek-slug",
    path: _91slug_93xIp3Xxj6mSpZoOL8bk69M4pTOtQqlu34pjO9HtsvYSEMeta?.path ?? "/shop/boek/:slug()",
    props: _91slug_93xIp3Xxj6mSpZoOL8bk69M4pTOtQqlu34pjO9HtsvYSEMeta?.props ?? false,
    meta: _91slug_93xIp3Xxj6mSpZoOL8bk69M4pTOtQqlu34pjO9HtsvYSEMeta || {},
    alias: _91slug_93xIp3Xxj6mSpZoOL8bk69M4pTOtQqlu34pjO9HtsvYSEMeta?.alias || [],
    redirect: _91slug_93xIp3Xxj6mSpZoOL8bk69M4pTOtQqlu34pjO9HtsvYSEMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/shop/boek/[slug].vue")
  },
  {
    name: indexwjQ7NVUXxiR0dGRxdexfgXvZBEDH2PvUto5_fdPDOv0Meta?.name ?? "shopboeken",
    path: indexwjQ7NVUXxiR0dGRxdexfgXvZBEDH2PvUto5_fdPDOv0Meta?.path ?? "/shopboeken",
    props: indexwjQ7NVUXxiR0dGRxdexfgXvZBEDH2PvUto5_fdPDOv0Meta?.props ?? false,
    meta: indexwjQ7NVUXxiR0dGRxdexfgXvZBEDH2PvUto5_fdPDOv0Meta || {},
    alias: indexwjQ7NVUXxiR0dGRxdexfgXvZBEDH2PvUto5_fdPDOv0Meta?.alias || [],
    redirect: indexwjQ7NVUXxiR0dGRxdexfgXvZBEDH2PvUto5_fdPDOv0Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/shopboeken/index.vue")
  },
  {
    name: indexOQFvQQJ4FlGKlu0ibmPwhIB_45yA1LPvwkeVxswPmkNOgMeta?.name ?? "boekenpraat",
    path: indexOQFvQQJ4FlGKlu0ibmPwhIB_45yA1LPvwkeVxswPmkNOgMeta?.path ?? "/boekenpraat",
    props: indexOQFvQQJ4FlGKlu0ibmPwhIB_45yA1LPvwkeVxswPmkNOgMeta?.props ?? false,
    meta: indexOQFvQQJ4FlGKlu0ibmPwhIB_45yA1LPvwkeVxswPmkNOgMeta || {},
    alias: indexOQFvQQJ4FlGKlu0ibmPwhIB_45yA1LPvwkeVxswPmkNOgMeta?.alias || [],
    redirect: indexOQFvQQJ4FlGKlu0ibmPwhIB_45yA1LPvwkeVxswPmkNOgMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/boekenpraat/index.vue")
  },
  {
    name: _91slug_93nXapy0aUU_DZzxuxTCDLZRFsJnTtu_SM_45_45P93ZaTYegMeta?.name ?? "boekenpraat-slug",
    path: _91slug_93nXapy0aUU_DZzxuxTCDLZRFsJnTtu_SM_45_45P93ZaTYegMeta?.path ?? "/boekenpraat/:slug()",
    props: _91slug_93nXapy0aUU_DZzxuxTCDLZRFsJnTtu_SM_45_45P93ZaTYegMeta?.props ?? false,
    meta: _91slug_93nXapy0aUU_DZzxuxTCDLZRFsJnTtu_SM_45_45P93ZaTYegMeta || {},
    alias: _91slug_93nXapy0aUU_DZzxuxTCDLZRFsJnTtu_SM_45_45P93ZaTYegMeta?.alias || [],
    redirect: _91slug_93nXapy0aUU_DZzxuxTCDLZRFsJnTtu_SM_45_45P93ZaTYegMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/boekenpraat/[slug].vue")
  },
  {
    name: wachtwoord_45vergetenPLlBIL91__ETXBBwRKr3mLE83db7w_45m23xPAYnRY0icMeta?.name ?? "wachtwoord-vergeten",
    path: wachtwoord_45vergetenPLlBIL91__ETXBBwRKr3mLE83db7w_45m23xPAYnRY0icMeta?.path ?? "/wachtwoord-vergeten",
    props: wachtwoord_45vergetenPLlBIL91__ETXBBwRKr3mLE83db7w_45m23xPAYnRY0icMeta?.props ?? false,
    meta: wachtwoord_45vergetenPLlBIL91__ETXBBwRKr3mLE83db7w_45m23xPAYnRY0icMeta || {},
    alias: wachtwoord_45vergetenPLlBIL91__ETXBBwRKr3mLE83db7w_45m23xPAYnRY0icMeta?.alias || [],
    redirect: wachtwoord_45vergetenPLlBIL91__ETXBBwRKr3mLE83db7w_45m23xPAYnRY0icMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/wachtwoord-vergeten.vue")
  },
  {
    name: algemene_45voorwaarden1chv4cbzzXep_kbnhOMHiswwhMbXYqBqvz1o_45xJMfhoMeta?.name ?? "algemene-voorwaarden",
    path: algemene_45voorwaarden1chv4cbzzXep_kbnhOMHiswwhMbXYqBqvz1o_45xJMfhoMeta?.path ?? "/algemene-voorwaarden",
    props: algemene_45voorwaarden1chv4cbzzXep_kbnhOMHiswwhMbXYqBqvz1o_45xJMfhoMeta?.props ?? false,
    meta: algemene_45voorwaarden1chv4cbzzXep_kbnhOMHiswwhMbXYqBqvz1o_45xJMfhoMeta || {},
    alias: algemene_45voorwaarden1chv4cbzzXep_kbnhOMHiswwhMbXYqBqvz1o_45xJMfhoMeta?.alias || [],
    redirect: algemene_45voorwaarden1chv4cbzzXep_kbnhOMHiswwhMbXYqBqvz1o_45xJMfhoMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/algemene-voorwaarden.vue")
  },
  {
    name: wachtwoord_45herstellenWXYRzTmVpSG3t0bd0Fv7GzV73tMjPZjfq_45C8B62YQF4Meta?.name ?? "wachtwoord-herstellen",
    path: wachtwoord_45herstellenWXYRzTmVpSG3t0bd0Fv7GzV73tMjPZjfq_45C8B62YQF4Meta?.path ?? "/wachtwoord-herstellen",
    props: wachtwoord_45herstellenWXYRzTmVpSG3t0bd0Fv7GzV73tMjPZjfq_45C8B62YQF4Meta?.props ?? false,
    meta: wachtwoord_45herstellenWXYRzTmVpSG3t0bd0Fv7GzV73tMjPZjfq_45C8B62YQF4Meta || {},
    alias: wachtwoord_45herstellenWXYRzTmVpSG3t0bd0Fv7GzV73tMjPZjfq_45C8B62YQF4Meta?.alias || [],
    redirect: wachtwoord_45herstellenWXYRzTmVpSG3t0bd0Fv7GzV73tMjPZjfq_45C8B62YQF4Meta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/wachtwoord-herstellen.vue")
  },
  {
    name: nieuwsbrief_45instellingen44u8U40fm83UaG3GZISxhHn86LFuHef7epgmEpyC7vYMeta?.name ?? "nieuwsbrief-instellingen",
    path: nieuwsbrief_45instellingen44u8U40fm83UaG3GZISxhHn86LFuHef7epgmEpyC7vYMeta?.path ?? "/nieuwsbrief-instellingen",
    props: nieuwsbrief_45instellingen44u8U40fm83UaG3GZISxhHn86LFuHef7epgmEpyC7vYMeta?.props ?? false,
    meta: nieuwsbrief_45instellingen44u8U40fm83UaG3GZISxhHn86LFuHef7epgmEpyC7vYMeta || {},
    alias: nieuwsbrief_45instellingen44u8U40fm83UaG3GZISxhHn86LFuHef7epgmEpyC7vYMeta?.alias || [],
    redirect: nieuwsbrief_45instellingen44u8U40fm83UaG3GZISxhHn86LFuHef7epgmEpyC7vYMeta?.redirect,
    component: () => import("/home/vsts/work/1/s/pages/nieuwsbrief-instellingen.vue")
  },
  {
    name: index7cJvl0uoOYdrVuUiHu47PmCeebvviFliZJpMqShDMJwMeta?.name ?? undefined,
    path: index7cJvl0uoOYdrVuUiHu47PmCeebvviFliZJpMqShDMJwMeta?.path ?? "/volgendemaand",
    props: index7cJvl0uoOYdrVuUiHu47PmCeebvviFliZJpMqShDMJwMeta?.props ?? false,
    meta: { ...(index7cJvl0uoOYdrVuUiHu47PmCeebvviFliZJpMqShDMJwMeta || {}), ...{"month":"next"} },
    alias: index7cJvl0uoOYdrVuUiHu47PmCeebvviFliZJpMqShDMJwMeta?.alias || [],
    redirect: index7cJvl0uoOYdrVuUiHu47PmCeebvviFliZJpMqShDMJwMeta?.redirect,
    component: () => import("~/pages/boeken/index.vue")
  },
  {
    name: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.name ?? undefined,
    path: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.path ?? "/aanbod/aanmelden",
    props: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.props ?? false,
    meta: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta || {},
    alias: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.alias || [],
    redirect: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.redirect,
    component: () => import("~/pages/promo/aanmelden.vue")
  },
  {
    name: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.name ?? undefined,
    path: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.path ?? "/aanbod/betalen",
    props: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.props ?? false,
    meta: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta || {},
    alias: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.alias || [],
    redirect: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.redirect,
    component: () => import("~/pages/promo/betalen.vue")
  },
  {
    name: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.name ?? undefined,
    path: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.path ?? "/aanbod/gelukt",
    props: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.props ?? false,
    meta: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta || {},
    alias: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.alias || [],
    redirect: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.redirect,
    component: () => import("~/pages/promo/gelukt.vue")
  },
  {
    name: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.name ?? undefined,
    path: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.path ?? "/aanbod/overzicht",
    props: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.props ?? false,
    meta: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta || {},
    alias: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.alias || [],
    redirect: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.redirect,
    component: () => import("~/pages/promo/overzicht.vue")
  },
  {
    name: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.name ?? undefined,
    path: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.path ?? "/aanbod/inloggen",
    props: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.props ?? false,
    meta: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta || {},
    alias: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.alias || [],
    redirect: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.redirect,
    component: () => import("~/pages/promo/inloggen.vue")
  },
  {
    name: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.name ?? undefined,
    path: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.path ?? "/campagne/aanmelden",
    props: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.props ?? false,
    meta: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta || {},
    alias: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.alias || [],
    redirect: aanmeldenRItpk42Y2ILAba_z8P8c6tskHmNl_45PHRwuv4KA8LwsgMeta?.redirect,
    component: () => import("~/pages/promo/aanmelden.vue")
  },
  {
    name: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.name ?? undefined,
    path: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.path ?? "/campagne/inloggen",
    props: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.props ?? false,
    meta: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta || {},
    alias: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.alias || [],
    redirect: inloggenv1PTEqG7n7qimW4rfSDaZUdqGwwIYDtDU9fMu0WeH04Meta?.redirect,
    component: () => import("~/pages/promo/inloggen.vue")
  },
  {
    name: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.name ?? undefined,
    path: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.path ?? "/campagne/betalen",
    props: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.props ?? false,
    meta: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta || {},
    alias: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.alias || [],
    redirect: betalen3GDoyutLKoU1ykVOuzq7sFVVnZ2mXRKLtvL1Xmka5QoMeta?.redirect,
    component: () => import("~/pages/promo/betalen.vue")
  },
  {
    name: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.name ?? undefined,
    path: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.path ?? "/campagne/overzicht",
    props: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.props ?? false,
    meta: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta || {},
    alias: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.alias || [],
    redirect: overzichtsrQkm6Nzs7xzI7aCp56gdIvXAVSUtj2sqwW1lwdZLwcMeta?.redirect,
    component: () => import("~/pages/promo/overzicht.vue")
  },
  {
    name: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.name ?? undefined,
    path: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.path ?? "/campagne/gelukt",
    props: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.props ?? false,
    meta: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta || {},
    alias: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.alias || [],
    redirect: geluktVxFm_1b4it0GKhbsXyVcCGJQklCDWTc5AAm4EiCSELoMeta?.redirect,
    component: () => import("~/pages/promo/gelukt.vue")
  },
  {
    name: _91slug_93Z_45hD6NNoHwxITjLDGraPRWho6xkzF3rywrNmjbwPPvkMeta?.name ?? "shopboek-lezen",
    path: _91slug_93Z_45hD6NNoHwxITjLDGraPRWho6xkzF3rywrNmjbwPPvkMeta?.path ?? "/shopboeken/lezen/:slug",
    props: _91slug_93Z_45hD6NNoHwxITjLDGraPRWho6xkzF3rywrNmjbwPPvkMeta?.props ?? false,
    meta: _91slug_93Z_45hD6NNoHwxITjLDGraPRWho6xkzF3rywrNmjbwPPvkMeta || {},
    alias: _91slug_93Z_45hD6NNoHwxITjLDGraPRWho6xkzF3rywrNmjbwPPvkMeta?.alias || [],
    redirect: _91slug_93Z_45hD6NNoHwxITjLDGraPRWho6xkzF3rywrNmjbwPPvkMeta?.redirect,
    component: () => import("~/pages/lezen/[slug].vue")
  },
  {
    name: index79Dtf__45zjyxjEqMVtlBDDX2KfC1j95a69AqafAVtBGUMeta?.name ?? undefined,
    path: index79Dtf__45zjyxjEqMVtlBDDX2KfC1j95a69AqafAVtBGUMeta?.path ?? "/archief/:slug",
    props: index79Dtf__45zjyxjEqMVtlBDDX2KfC1j95a69AqafAVtBGUMeta?.props ?? false,
    meta: index79Dtf__45zjyxjEqMVtlBDDX2KfC1j95a69AqafAVtBGUMeta || {},
    alias: index79Dtf__45zjyxjEqMVtlBDDX2KfC1j95a69AqafAVtBGUMeta?.alias || [],
    redirect: index79Dtf__45zjyxjEqMVtlBDDX2KfC1j95a69AqafAVtBGUMeta?.redirect,
    component: () => import("~/pages/archief/index.vue")
  },
  {
    name: indexRgFr3GujSt_uqIVaAl6xQwLR_phmsmPXCk14NuLQuqwMeta?.name ?? undefined,
    path: indexRgFr3GujSt_uqIVaAl6xQwLR_phmsmPXCk14NuLQuqwMeta?.path ?? "/help/:slug",
    props: indexRgFr3GujSt_uqIVaAl6xQwLR_phmsmPXCk14NuLQuqwMeta?.props ?? false,
    meta: indexRgFr3GujSt_uqIVaAl6xQwLR_phmsmPXCk14NuLQuqwMeta || {},
    alias: indexRgFr3GujSt_uqIVaAl6xQwLR_phmsmPXCk14NuLQuqwMeta?.alias || [],
    redirect: indexRgFr3GujSt_uqIVaAl6xQwLR_phmsmPXCk14NuLQuqwMeta?.redirect,
    component: () => import("~/pages/help/index.vue")
  }
]